module.exports = __webpack_public_path__ + "img/grayCircledCheckMark.e5bcdce3.svg";